import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4CostTexasArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';

    document.title = 'How Much Does HO-4 Cost in Texas? | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        'content',
        'Learn typical HO-4 renters insurance costs in Texas and what factors change your monthly premium.'
      );
    }

    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/how-much-does-ho4-cost-in-texas"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>How much does HO-4 cost in Texas?</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>
              A simple breakdown of typical premium ranges and the biggest pricing factors.
            </p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4"><div className="card-body">
            <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
            <p>Many Texas renters see HO-4 premiums in an affordable monthly range, but your exact price depends on deductible, liability limit, location, and claims history.</p>
            <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>What impacts your cost most</h3>
            <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>Liability limit selection.</li>
              <li style={{ marginBottom: '0.5rem' }}>Deductible amount.</li>
              <li style={{ marginBottom: '0.5rem' }}>ZIP code and building profile.</li>
              <li>Prior claims and optional endorsements.</li>
            </ul>
            <p style={{ marginTop: '1rem', marginBottom: 0 }}>
              To choose your limit first, see <Link to="/knowledge-base/how-much-liability-do-i-need-for-renters-insurance" style={articleLinkStyle}>how much liability you may need</Link>. Then pair it with the right <Link to="/knowledge-base/what-deductible-should-i-choose-for-ho4" style={articleLinkStyle}>HO-4 deductible</Link>.
            </p>
          </div></article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>Compare HO-4 options and find pricing that fits your budget.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Need help comparing quotes?</h3>
              <p style={{ marginBottom: '1rem' }}>An agent can help balance price and coverage for your lease requirements.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4CostTexasArticlePage;

